import isOnline from 'src/components/10-atoms/network/utils/isOnline';
import db from 'src/lib/dexie-db/db';
import { ImageCacheStatus } from 'src/lib/sync-box/image-cache/types';
import { NodeType } from 'src/modules/exam-preparation/graphql/common/types/node';
import { getSafeData } from './utils';
const DiagramAPIs = {
    async search(userID, filters, pagination = { offset: 0 }) {
        const { offset = 0, limit = 20 } = pagination;
        function getQuery() {
            let query = db.qnaNode
                .where('type')
                .equals(NodeType.DIAGRAM)
                .and(node => !node.deleted)
                .and(node => !isOnline() ? node.data.imageCacheInfo?.status === ImageCacheStatus.CACHED : true);
            if (filters.ancestorID) {
                query = query.and(node => node.ancestors?.includes(filters.ancestorID || ''));
            }
            if (filters.topic) {
                query = query.and(node => (node.data?.topics || []).includes(filters.topic));
            }
            if (filters.query) {
                const q = filters.query || '';
                query = query.and(node => {
                    const title = node.data?.title?.toLowerCase() || '';
                    const description = node.data?.description?.toLowerCase() || '';
                    return title.includes(q.toLowerCase()) || description.includes(q.toLowerCase());
                });
            }
            return query;
        }
        const diagrams = await getQuery().offset(offset).limit(limit).toArray();
        const totalCount = await getQuery().count();
        return {
            list: diagrams.map(getSafeData),
            totalCount,
        };
    },
};
export default DiagramAPIs;
